import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFlag12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconFlag12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M1 8v3.5a.5.5 0 0 0 1 0V8h8.844a.5.5 0 0 0 .365-.842L8.712 4.5l2.497-2.658A.5.5 0 0 0 10.844 1H2V.5a.5.5 0 0 0-1 0zm1-6v5h7.688L7.983 5.185 7.34 4.5l.643-.685L9.688 2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFlag12);
